module.exports = {
  src: __webpack_public_path__ + "static/media/frontpage_00006.717f30d8.jpg",
  width: 2000,
  height: 1667,
  bytes: 447922,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/frontpage_00006.717f30d8.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/frontpage/frontpage_00006.jpg
// module id = 167
// module chunks = 0